module.exports = __webpack_public_path__ + "img/inner-6.d5214534.png";